/**
 * Auth card shell (APP-001 §8).
 *
 * Centered, branded container for the Clerk sign-in/sign-up components.
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function AuthCard({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className={cn('w-full max-w-md rounded-lg border bg-surface p-6 shadow-sm sm:p-8', className)}>
        {children}
      </div>
    </div>
  );
}
